import * as React from "react";
import { Link } from "@fluentui/react";
import { parseId } from "../../helpers/idHelper";
import { useAppAuthContext } from "../../hooks/useAppAuthContext";
import { azurePortalUrl } from "../../utils";

export interface AzureSubnetLinkProps {
  subnetId: string;
}

export const AzureSubnetLink = (
  { subnetId }: AzureSubnetLinkProps,
): JSX.Element => {
  const { domainName } = useAppAuthContext();
  const subnet = decodeURIComponent(parseId(subnetId)?.resourceName || "");

  return (
    <Link
      // eslint-disable-next-line max-len
      href={`${azurePortalUrl}/#@${domainName}/resource${subnetId}/overview`}
      target="_blank"
    >
      {subnet}
    </Link>
  );
};
